export enum ExistResultStatus {
    existResult = 1,
    notExistResult = 2
}
